(ns net.kestec.mhda-pilgrimage.admin.applications.application-events
  (:require
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.route :as-alias route]
    [ajax.core :as ajax]
    [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as-alias admin-applications-events]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    ))


(rf/reg-event-fx
  ::load-application
  (fn [{db :db} _]
    (println "load admin application")
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                         "/application/" (get-in db [::route/route :path-params :application-id]))
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::db/admin-selected-application]
                   :on-failure      [::db/log-error]}]}))


(rf/reg-event-fx
  ::reload-actual-and-list
  (fn [{db :db} [_ t]]
    {:dispatch-n
     [[::load-application]
      [::load-validator-details]
      [::admin-applications-events/load-applications]
      ]}))

(rf/reg-event-fx
  ::load-validator-details
  (fn [{db :db} _]
    (println "load admin application validation")
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                         "/application/" (get-in db [::route/route :path-params :application-id]) "/validation")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::db/admin-selected-application-validation]
                   :on-failure      [::db/log-error]}]}))


(rf/reg-event-fx
  ::update-application
  (fn [{db :db} [_ id values]]
    (println "admin-update-application " id values)
    {:http-xhrio [{:method          :put
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                         "/application/" id)
                   :params          values
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::reload-actual-and-list]
                   :on-failure      [::db/log-error]}]}))

(rf/reg-event-fx
  ::delete-application
  (fn [{db :db} [_ id]]
    (println "admin-delete-application " id)
    {:http-xhrio [{:method          :delete
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                         "/application/" id)
                   :format          (ajax/json-request-format)
                   :response-format (ajax/text-response-format)
                   :on-success      [::reload-actual-and-list]
                   :on-failure      [::db/log-error]}]}))

(rf/reg-event-fx
  ::update-actual-application
  (fn [{db :db} _]
    (println "update-actual-application" (get-in db [::route/route :path-params :pilgrimage-id]) " - " (get-in db [::route/route :path-params :application-id]))
    {:http-xhrio [{:method          :put
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                         "/application/" (get-in db [::route/route :path-params :application-id]))
                   :params          (::db/admin-selected-application db)
                   :format          (ajax/json-request-format)
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::reload-actual-and-list]
                   :on-failure      [::db/log-error]}]}))


(rf/reg-event-db
  ::set-status-popup-application
  (fn [db [_ id]]
    (assoc db ::db/status-popup-application id)))

(rf/reg-event-db
  ::show-delete-popup
  (fn [db [_ id]]
    (assoc db ::db/show-delete-popup id)))


(rf/reg-event-db
  ::set-payment-popup-application
  (fn [db [_ id]]
    (assoc db ::db/payment-popup-application id)))




(rf/reg-event-fx
  ::store-nurse-documents
  (fn [{db :db} [_ files]]
    {:http-xhrio (mapv (fn [^js file]
                         {:method          :post
                          :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                                "/application/" (get-in db [::route/route :path-params :application-id])
                                                "/files")
                          :body            file
                          :headers         {"Content-Type"      "application/octet-stream"
                                            "File-Name"         (.-name file)
                                            "File-Content-Type" (.-type file)
                                            }
                          :response-format (ajax/text-response-format)
                          :on-success      [::nurse-document-uploaded (.-name file) (.-type file)]
                          :on-failure      [::db/log-error]})
                       files)}))


(rf/reg-event-fx
  ::nurse-document-uploaded
  (fn [{db :db} [_ file-name file-type file]]
    (println "::nurse-document-uploaded" file-name file-type file)
    {:db       (update-in db [::db/admin-selected-application :nurse_documents] conj
                          {:file_name file-name
                           :file_type file-type
                           :file      file})
     :dispatch [::update-actual-application]
     }))

(rf/reg-event-fx
  ::remove-nurse-document
  (fn [{db :db} [_ id]]
    (println "::remove-med-document" id (get-in db [::db/admin-selected-application]))
    {:db       (update-in db [::db/admin-selected-application :nurse_documents] (fn [docs] (println "::remove-med-document" id docs) (remove #(= id (:file %)) docs)))
     :dispatch [::update-actual-application]
     }))

(rf/reg-event-fx
  ::store-med-documents
  (fn [{db :db} [_ files]]
    {:http-xhrio (mapv (fn [^js file]
                         {:method          :post
                          :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id])
                                                "/application/" (get-in db [::route/route :path-params :application-id])
                                                "/files")
                          :body            file
                          :headers         {"Content-Type"      "application/octet-stream"
                                            "File-Name"         (.-name file)
                                            "File-Content-Type" (.-type file)
                                            }
                          :response-format (ajax/text-response-format)
                          :on-success      [::med-document-uploaded (.-name file) (.-type file)]
                          :on-failure      [::db/log-error]})
                       files)}))


(rf/reg-event-fx
  ::med-document-uploaded
  (fn [{db :db} [_ file-name file-type file]]
    (println "::med-document-uploaded" file-name file-type file)
    {:db       (update-in db [::db/admin-selected-application :med_documents] conj
                          {:file_name file-name
                           :file_type file-type
                           :file      file})
     :dispatch [::update-actual-application]
     }))


(rf/reg-event-fx
  ::remove-med-document
  (fn [{db :db} [_ id]]
    (println "::remove-med-document" id (get-in db [::db/admin-selected-application]))
    {:db       (update-in db [::db/admin-selected-application :med_documents] (fn [docs] (println "::remove-med-document" id docs) (remove #(= id (:file %)) docs)))
     :dispatch [::update-actual-application]
     }))

(rf/reg-event-db
  ::set-show-are-you-sure-popup
  (fn [db [_ msg delete-event]]
    (assoc db ::show-are-you-sure-popup {:msg msg :delete-event delete-event})))
